export const grades = [
    'excellent', 'very_good', 'good'
];
